/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PredictionPickResponse
 */
export interface PredictionPickResponse {
    /**
     * 
     * @type {string}
     * @memberof PredictionPickResponse
     */
    pickedOutcomeId: string;
    /**
     * 
     * @type {number}
     * @memberof PredictionPickResponse
     */
    picksLockedAt?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PredictionPickResponse
     */
    resolved: boolean;
    /**
     * 
     * @type {number}
     * @memberof PredictionPickResponse
     */
    totalPicks: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PredictionPickResponse
     */
    outcomeCounts: { [key: string]: number; };
}

/**
 * Check if a given object implements the PredictionPickResponse interface.
 */
export function instanceOfPredictionPickResponse(value: object): value is PredictionPickResponse {
    if (!('pickedOutcomeId' in value) || value['pickedOutcomeId'] === undefined) return false;
    if (!('resolved' in value) || value['resolved'] === undefined) return false;
    if (!('totalPicks' in value) || value['totalPicks'] === undefined) return false;
    if (!('outcomeCounts' in value) || value['outcomeCounts'] === undefined) return false;
    return true;
}

export function PredictionPickResponseFromJSON(json: any): PredictionPickResponse {
    return PredictionPickResponseFromJSONTyped(json, false);
}

export function PredictionPickResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredictionPickResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'pickedOutcomeId': json['pickedOutcomeId'],
        'picksLockedAt': json['picksLockedAt'] == null ? undefined : json['picksLockedAt'],
        'resolved': json['resolved'],
        'totalPicks': json['totalPicks'],
        'outcomeCounts': json['outcomeCounts'],
    };
}

export function PredictionPickResponseToJSON(json: any): PredictionPickResponse {
    return PredictionPickResponseToJSONTyped(json, false);
}

export function PredictionPickResponseToJSONTyped(value?: PredictionPickResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pickedOutcomeId': value['pickedOutcomeId'],
        'picksLockedAt': value['picksLockedAt'],
        'resolved': value['resolved'],
        'totalPicks': value['totalPicks'],
        'outcomeCounts': value['outcomeCounts'],
    };
}

